// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2t-Z0","label":"Labeled_label__XAiTr","divider":"Labeled_divider__24Xiq"};